import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./PackDescriptionComponent.css";
import hdIcon from "../hd-icon.svg";
import sdIcon from "../sd-icon.svg";
import defaultChannel from "../default-channel.png";
import '../../../assets/fontello/css/fontello.css';



export default function PackDescriptionComponent(props) {
  const [botChatWrap, setBotChatWrap] = useState(null);

  useEffect(() => {
    const container = document.querySelector(
      props?.showMaximumChat ? ".fullPageBotContainer" : ".bot-chat-wrap"
    );
    if (container) setBotChatWrap(container);
  }, [props?.showMaximumChat]);
  

  const toggledStyle = {
    height: "14rem",
    overflowY: "scroll",
  };
  const [toggle, setToggle] = useState(1);
  const [showMoreToggle, setShowMoreToggle] = useState(null);
  const { data } = props;

  const componentUI = (
    <div style={{background :props?.showMaximumChat  && "rgba(0, 0, 0, 0.5)"}} className="popup-overlay">
      <div className="popup-content-packs" style={{width : props?.showMaximumChat ? "50%" : "100%"}}>
        <div className="packDescriptionContainer chatIn-header help-assistantwrapp">
          <div className="packDescriptionClose" onClick={props.closeDescriptionComponent}>
            <i className="demo-icon icon-close-1"></i>
          </div>
          <div className="header-packsDescription">
            <div className="header-packsDescription-title">
              <p>{data?.name}</p>
            </div>
            <div className="header-packsDescription-overView">
              <div className="header-packsDescription-left">
                <div className="totalChannels">Total Channels</div>
                <div className="hdSdContaoiner-left">
                  <div className="hdSdBox">
                    <img src={hdIcon} alt="HD" />
                    <p>{data?.noOfHdChannels}</p>
                  </div>
                  <div className="hdSdBox">
                    <img src={sdIcon} alt="SD" />
                    <p>{data?.noOfSdChannels}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="middle-packsDescription">
            {data?.moreDetails && data?.moreDetails?.viewChannelList?.length !== 0 ? (
              data?.moreDetails?.viewChannelList?.map((onePack, index) => (
                <div className="oneCategoryContainer"  style={{marginTop : index === 0 && "20px" , border : toggle === index ? "1px solid #ebbbeb" : "1px solid #ccc" }} key={index}> 
                  <div
                    className="oneCategory-header"
                    onClick={() => setToggle(toggle === index ? null : index)}
                    style={{
                      // backgroundColor: index === toggle ? "#f5f5f5" : "white",
                      // border: index === toggle ? "1px solid #e10092" : "white",
                      borderBottom: index === toggle && "none",
                      borderRadius: index === toggle && "12px" ,
                      flexDirection : "row",
                      display : 'flex',
                      width :'100%',
                      cursor: "pointer",
                    }}
                    //style={{border: index === toggle ? "1px solid #e10092" : "white",}}
                  >
                    <div className="category-header-name">
                      <p>{onePack?.name}</p>
                    </div>
                    <div className="countandArrow">

                      <div>
                        <p>{`${onePack?.noOfChannels} Channels`}</p>
                      </div>
                      {toggle === index ? (
                        <div className="arrow-up" ></div>
                      ) : (
                        <div className="arrow-down" ></div>
                      )}
                    </div>
                  </div>
                  {toggle === index && (
                    <div className={showMoreToggle === index ? "channlesContainer-desc-more" : "channlesContainer-desc"}>
                      {onePack?.channelList.map((oneChannel) => (
                        <div className="oneChannelBox-desc" key={oneChannel?.name}>
                          <div className="oneChannel-image">
                            <img src={oneChannel.imageLink} onError={(e) => (e.target.src = defaultChannel)} alt="Channel" />
                          </div>
                          <div className="oneChannel-name" style={{display : 'flex' , justifyContent : 'center', whiteSpace :'pre-line', flexDirection :'column'}}>{oneChannel?.name} <div style={{marginLeft : '4px'}}>({oneChannel.channelNo})</div></div>
                          <div className="oneChannel-no">{oneChannel?.ChanelNo}</div>
                        </div>
                      ))}
                    </div>
                  )}
                  {onePack?.noOfChannels > 4 && (
                    <div className="showMoreLessToggle" style={{ marginTop: toggle === index ? "5%" : "0%" }}>
                      {toggle === index && (
                        showMoreToggle === index ? (
                          <p onClick={() => setShowMoreToggle(null)}>View Less</p>
                        ) : (
                          <p onClick={() => setShowMoreToggle(index)}> View All</p>
                        )
                      )}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="channlesContainer-desc-more">
                {data?.channelDetials?.map((oneChannel) => (
                  <div className="oneChannelBox-desc" key={oneChannel?.name}>
                    <div className="oneChannel-image">
                      <img src={oneChannel?.imageLink} onError={(e) => (e.target.src = defaultChannel)} alt="Channel" />
                    </div>
                    <div className="oneChannel-name" style={{display : 'flex' , justifyContent : 'center'}}>{oneChannel?.name} <div style={{marginLeft : '4px'}}>({oneChannel.channelNo})</div></div>
                    <div className="oneChannel-no">{oneChannel?.ChanelNo}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {!props?.explorePacksCheck && <div className="footer-packsDescription">
            <button className="btn btn-secondary mT10 waves-effect waves-light close-model" onClick={props.closeDescriptionComponent}>
              <p>Go Back to Chat</p>
            </button>
            {!props?.showGetPack && <button className="btn btn-secondary mT10 waves-effect waves-light close-model" onClick={props.selectDesctipon} disabled={props?.data?.checked}>
              <p>Get This Pack</p>
            </button>}
          </div>}
        </div>
      </div>
    </div>
  );
  // return ReactDOM.createPortal(componentUI, document.body);



  return botChatWrap ? ReactDOM.createPortal(componentUI, botChatWrap) : null;
}
